import 'datatables.net/js/jquery.dataTables.min';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min';
import 'datatables.net-rowgroup/js/dataTables.rowGroup.min';

const languageSettings = {
  sProcessing: 'Procesando...',
  sLengthMenu: 'Mostrar _MENU_ registros',
  sZeroRecords: 'No se encontraron resultados',
  sEmptyTable: 'Ningún dato disponible en esta tabla',
  sInfo:
    'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
  sInfoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
  sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
  sInfoPostFix: '',
  sSearch: 'Buscar:',
  sUrl: '',
  sInfoThousands: ',',
  sLoadingRecords: 'Cargando...',
  oPaginate: {
    sFirst: 'Primero',
    sLast: 'Último',
    sNext: 'Siguiente',
    sPrevious: 'Anterior',
  },
  oAria: {
    sSortAscending: ': Activar para ordenar la columna de manera ascendente',
    sSortDescending: ': Activar para ordenar la columna de manera descendente',
  },
};

document.addEventListener('turbolinks:load', function () {
  $('#area_locations_datatable').DataTable({
    language: languageSettings,
    order: [],
  });
  $('#warehouse_areas_datatable').DataTable({
    language: languageSettings,
    order: [[0, 'asc']],
  });
  $('#product_lots_datatable').DataTable({
    language: languageSettings,
    order: [
      [1, 'asc'],
      [0, 'asc'],
    ],
  });
  $('#workstations_datatable').DataTable({
    language: languageSettings,
    order: [[0, 'asc']],
  });
  $('#item_receipts_table').DataTable({
    language: languageSettings,
  });
  $('#item_issues_table').DataTable({
    language: languageSettings,
  });
  $('#item_adjustments_table').DataTable({
    language: languageSettings,
  });
  $('#work_orders_asset_table').DataTable({
    language: languageSettings,
  });
  $('#maintenance_ocurrences_table').DataTable({
    language: languageSettings,
    order: [[0, 'desc']],
  });
  $('#role_permissions_table').DataTable({
    language: languageSettings,
    scrollY: '500px',
    scrollCollapse: true,
    order: [
      [0, 'asc'],
      [1, 'asc'],
    ],
    paging: false,
  });

  if (document.querySelector('#lot-locations-datatable')) {
    const lotLocationsDatatable = $('#lot-locations-datatable').DataTable({
      language: languageSettings,
      stateSave: true,
      orderFixed: [[2, 'asc']],
      rowGroup: {
        dataSrc: 2,
        className: 'table-row-group',
        startRender(rows, group) {
          return `${group} (${rows.count()})`;
        },
      },
    });

    // Change the fixed ordering when the data source is updated
    lotLocationsDatatable.on('rowgroup-datasrc', function (e, dt, val) {
      lotLocationsDatatable.order.fixed({ pre: [[val, 'asc']] }).draw();
    });

    $('input[name="group_by_column"]').on('click', function () {
      lotLocationsDatatable.rowGroup().dataSrc($(this).val());
    });
  }
});
